<template>
	<div class="button-description-group">
		<Button large @click="$emit('buttonClick')" :danger="color === 'red'">
			{{ buttonText }}
		</Button>
		<p class="explanation-text">
			<slot />
		</p>
	</div>
</template>

<script>
import { Button } from '@/components/common'

export default {
	components: { Button },
	emits: ['buttonClick'],
	props: {
		buttonText: {
			type: String,
			default: '',
		},
		color: {
			type: String,
			default: 'gray',
		},
	},
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables.scss';

.button-description-group {
	background: var(--neutral-100);
	border: 1px solid var(--neutral-200);
	border-radius: 4px;
	padding: 16px;
	@include flex(16px);

	.pronto-btn {
		width: 170px;
		justify-content: center;
	}

	p {
		margin: 0;
		color: var(--neutral-600);
		flex: 1;
	}
}
</style>
